// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// DELETE CONFIRM MODAL - Training System
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

import React from 'react';
import { useTranslation } from 'react-i18next';
import './DeleteConfirmModal.css';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  title: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay" onClick={onCancel}>
      <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-icon">
          <div className="warning-circle">
            <span>⚠️</span>
          </div>
        </div>

        <h3 className="delete-modal-title">{title}</h3>
        
        {message && (
          <p className="delete-modal-message">{message}</p>
        )}

        <div className="delete-modal-actions">
          <button onClick={onCancel} className="btn-cancel">
            {t('common.cancel')}
          </button>
          <button onClick={onConfirm} className="btn-delete">
            {t('common.delete')}
          </button>
        </div>
      </div>
    </div>
  );
};

